export class ExportExcelIN {
    listIdProgetto: number[]
}
